module.exports = __webpack_public_path__ + "img/introduction_img1.4dd4a240.png";